import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import queryString from 'query-string';
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class LoginNopin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingButton: false,
            error: false,
            email: "",
            password: ""
        };
    };

    componentWillMount(){
        window.scrollTo(0, 0);
        //document.addEventListener("keydown", this._handleKeyDown.bind(this));
        this._checkToken();
    }

    componentWillUnmount() {
        //document.removeEventListener("keydown", this._handleKeyDown.bind(this));
    }

    _handleKeyDown(event){
        var ENTER_KEY = 13;
        switch( event.keyCode ) {
            case ENTER_KEY:
                this._register();
                break;
            default:
                break;
        }
    }

    _checkToken(){
        let token = tokenRegister.get();
        if(token){
            let query = queryString.parse(this.props.location.search);
            if(query.from_path){
                this.props.history.push(query.from_path);
            }else if(query.to){
                this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + query.to);
            }else{
                this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
            }
        }
    }

    _signup() {
        let query = queryString.parse(this.props.location.search);
        if(query.from_path){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register?from_path=" + query.from_path);
        }else if(query.to){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register?from_path=" + query.to);
        }else{
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register");
        }
    }

    _register() {
        this.setState({isLoadingButton: true, error: false});
        let user = {email: this.state.email, password: this.state.password};
        dataRegister.login(marketRegister.code(), user).then((response) => {
            if(!response.errors){
                response.email = this.state.email;
                userRegister.set(response);
                let query = queryString.parse(this.props.location.search);
                if(query.from_path){
                    this.props.history.push(query.from_path);
                }else if(query.from){
                    this.props.history.push(query.from);
                }else if(query.to){
                    this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + query.to);
                }else{
                    this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
                }
            }else{
                this.setState({isLoadingButton: false, error: true});
            }
        }, (error) => {
            this.setState({isLoadingButton: false, error: true});
        });
    }

    _forgot(){
        this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/forgot-password");
    }

    _renderButton() {
        if (!this.state.isLoadingButton) {
            return (this._renderText("item_5"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }

    _renderText(item) {
        return langRegister.get("login-nopin", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"login"} props={this.props}/>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <div className={Styles.inputWrapper}>
                        <input
                            className={cx(Styles.input)}
                            type={"email"}
                            placeholder={this._renderText("item_3")}
                            value={this.state.email}
                            onChange={(event) => this.setState({email: event.target.value})}
                        />
                        {
                            this.state.error &&
                            <div className={Styles.inputError}/>
                        }
                    </div>
                    <div className={Styles.inputWrapper}>
                        <input
                            className={cx(Styles.inputPassword)}
                            type={"password"}
                            placeholder={this._renderText("item_4")}
                            value={this.state.password}
                            onChange={(event) => this.setState({password: event.target.value})}
                        />
                        <div onClick={() => this._forgot()} className={Styles.inputPasswordForgot}>
                            {this._renderText("item_8")}
                        </div>
                        {
                            this.state.error &&
                            <div className={Styles.inputError}/>
                        }
                    </div>
                    <div onClick={() => this._register()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    <div className={Styles.text}>
                        {this._renderText("item_6")}<span onClick={() => this._signup()} className={Styles.textBold}>{this._renderText("item_7")}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginNopin;


// WEBPACK FOOTER //
// ./src/pages/login-nopin/component.js